<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" style="box-sizing: border-box;">
    <!-- 个人中心 -->
    <div class="user_info">
      <notic :ScrollObj="ScrollObj"/>
      <!-- <standing_switch /> -->
      <Title title="个人信息"/>
      <div class="user flex">
        <div class="user_user_box flex">
          <div>
            <p class="name">用户名</p>
            <p class="info_0">{{ user_info.username }}</p>
          </div>
          <div>
            <p class="name">手机号</p>
            <p class="info_0">{{ user_info.mobile }}</p>
          </div>
          <div>
            <p class="name">会员等级</p>
            <p class="info_0">{{ user_info.group_name }}</p>
          </div>
          <div>
            <p class="name">账户余额</p>
            <p class="info_0">￥{{ user_info.money }}</p>
          </div>
          <div>
            <p class="name">钱包</p>
            <p class="info_0">￥{{ user_info.wallet }}</p>
          </div>
          <button class="topUp" @click="goRecharge()">立即充值
          </button>
        </div>
        <div class="flex" v-if="user_info.custom_info">
          <img :src="user_info.custom_info.avatar" alt="" style="width: 10rem;">
          <div class="user_name_info flex" v-if="user_info.custom_info">
            <p>专属客户经理</p>
            <p>姓名: {{ user_info.custom_info.nickname }}</p>
            <p>QQ: {{ user_info.custom_info.qq }}</p>
            <p>手机号: {{ user_info.custom_info.mobile }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="user_info2">
      <Title title="常用功能"/>
      <div class="user2 flex">
        <div @click="child_tab(item)" v-for="(item, index) in FunList" :key="index">
          <img :src="item.imgUrl" alt="">
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
    <div class="user_info3">
      <div class="user_status flex">
        <Title title="近3天订单状态"/>
        <ul class="status_box flex">
          <li @click="tabSwitch(item)" :class="order_status.id === item.id ? 'active' : ''"
              v-for="(item, index) in StatusList" :key="index">{{ item.title }}
          </li>
        </ul>
      </div>
      <el-table stripe :fit="true" :data="tableData" style="width: 100%;margin-bottom: 20px;" height="300"
                class="el_table">
        <el-table-column fixed prop="sn" label="订单号" width="150">
        </el-table-column>
        <el-table-column fixed prop="title" label="标题" width="300">
        </el-table-column>
        <el-table-column fixed prop="date" label="媒介类别" width="150">
          <template slot-scope="scope">
            <p class="media_num">{{ scope.row.category_title }}</p>
          </template>
        </el-table-column>
        <el-table-column fixed prop="date" label="媒介名称" width="150">
          <template slot-scope="scope">
            <p class="media_num">{{ scope.row.medium_title }}</p>
          </template>
        </el-table-column>
        <el-table-column fixed prop="order_price" label="金额">
        </el-table-column>
        <el-table-column fixed prop="date" label="状态">
          <template slot-scope="scope">
            <span style="">{{
                scope.row.order_status == 0 ? '未处理' : scope.row.order_status == 1 ? '发布中' : scope.row.order_status == 2 ?
                    '已发稿' : scope.row.order_status == 3 ? '申请退款' : scope.row.order_status == 4 ? '拒绝退款' : '撤稿'
              }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed prop="order_time" label="下单时间">
        </el-table-column>
      </el-table>
    </div>
    <pagination :page="page" @pageChange="pageChange" :count="count" :total_page="total_page"/>
  </div>
</template>
<script>
import Title from '@/components/UserInfoTitle.vue'
import standing_switch from '@/components/standing_switch.vue'
import notic from '@/components/notic.vue'
import {timeCut} from '@/util/timeCut'

export default {
  name: '',
  components: {
    Title,
    notic,
    standing_switch
  },
  mounted() {
    this.getUserInfo()
    this.fullscreenLoading = true
    this.get_list()
    this.getNotic()
    this.fullscreenLoading = false
  },
  data() {
    return {
      ScrollObj: [],
      FunList: [
        {
          imgUrl: require('@/assets/user/index/zaixianchongzhi.png'),
          title: '在线充值',
          activeTitle: '在线充值',
          path: '/user/refill'
        },
        {
          imgUrl: require('@/assets/user/index/fapiaoshenqing.png'),
          title: '发票申请',
          activeTitle: '申请发票',
          path: '/user/apply_for_invoice/apply_for_invoice_data'
        },
        {
          imgUrl: require('@/assets/user/index/meitiziyuan.png'),
          title: '媒介资源',
          activeTitle: '选择媒介',
          path: '/user/user_media/News',
        },
        {
          imgUrl: require('@/assets/user/index/Chat.png'),
          title: '智能生成',
          activeTitle: '智能生成',
          path: '/user/Myword',
        },
        {
          imgUrl: require('@/assets/ai/30.png'),
          title: 'AI数字人',
          activeTitle: 'AI数字人',
          path: '/user/digitalHumanRecord',
        },
        {
          imgUrl: require('@/assets/user/index/changyonggongneng.png'),
          title: '工单管理',
          activeTitle: '我的工单',
          path: '/user/MyOrder'
        },
        {
          imgUrl: require('@/assets/user/index/lishifabu.png'),
          title: '历史发布',
          activeTitle: '媒介订单',
          path: '/user/MediaOrder',
          query: {
            status: 2
          }
        },
        // {
        //   imgUrl: require('@/assets/user/index/tuigaojilu.png'),
        //   title: '退稿记录',
        //   activeTitle: '退稿记录',
        //   path: '/user/MediaOrder',
        // },
      ],
      StatusList: [{
        id: '',
        title: '全部',
      }, {
        id: 0,
        title: '未处理'
      }, {
        id: 1,
        title: '发布中'
      }, {
        id: 2,
        title: '已出稿'
      }, {
        id: 3,
        title: '申请退款'
      }, {
        id: 4,
        title: '拒绝退款'
      }, {
        id: 5,
        title: '撤稿'
      },],
      tableData: [],
      fullscreenLoading: false,
      page: 1,
      total_page: 0, //分页
      count: 0, //总条数
      order_status: {
        id: '',
        title: '全部'
      },
      user_info: {},
    }
  },
  methods: {
    goRecharge() {
      console.log(1111)
      this.$router.push({
        path: '/user/refill'
      })
    },
    getNotic() {
      this.curlGet('/api/gonggao').then(res => {
        if (res.data.code) {
          this.ScrollObj = res.data.data
        }
      })
    },

    pageChange(pageVal) {
      console.log(pageVal);
      this.page = pageVal
      this.get_list()
    },
    // 获取用户信息
    getUserInfo() {
      this.curlGet('/api/user/info', {}).then(res => {
        if (res.data.code) {
          this.user_info = res.data.data
          this.$user_info = res.data.data
          this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
        }
      })
    },
    tabSwitch(item) {
      // console.log('点击', item)
      this.order_status = item
      this.get_list()
    },
    child_tab(item) {
      console.log(item)
      this.$store.commit('SETACTIVEMENU', item.path)
      this.$router.push({
        path: item.path,
        query: item.query || {}
      })

    },
    get_list() {
      let data = {}
      // console.log(this.order_status);
      data.page = this.page
      data.limit = 5
      if (this.order_status.id !== '') {
        data.order_status = this.order_status.id
      }
      console.log(data)
      this.curlGet('/api/users/order/list', data).then(res => {
        if (res.data.code) {
          this.total_page = res.data.data.total_page
          this.count = res.data.data.count
          this.tableData = res.data.data.list
          this.tableData.forEach((item, index) => {
            this.tableData[index].order_time = timeCut(this.tableData[index].order_time * 1000)

          })
        }
      })
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/UserInfo';
</style>